import { Injectable, Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

const QUERY_TABLET  = '(min-width: 768px)';
const QUERY_DESKTOP = '(min-width: 1024px)';

@Injectable({ providedIn: 'root' })
export class BreakpointService {
  private bo = inject(BreakpointObserver);

  private matches = toSignal(
    this.bo.observe([QUERY_TABLET, QUERY_DESKTOP]),
    { initialValue: { matches: false, breakpoints: { [QUERY_TABLET]: false, [QUERY_DESKTOP]: false } } as BreakpointState },
  );

  readonly isDesktop: Signal<boolean> = computed(() => this.matches().breakpoints[QUERY_DESKTOP]);
  readonly isTablet:  Signal<boolean> = computed(() => this.matches().breakpoints[QUERY_TABLET] && !this.isDesktop());
  readonly isPhone:   Signal<boolean> = computed(() => !this.isTablet() && !this.isDesktop());
}
